import { render, staticRenderFns } from "./DoubleAuctionMarket.vue?vue&type=template&id=1120f61b"
import script from "./DoubleAuctionMarket.vue?vue&type=script&lang=js"
export * from "./DoubleAuctionMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports